import React, { Dispatch, SetStateAction, useCallback } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Input from '@dealroadshow/uikit/core/components/Input';
import IconTrash from '@dealroadshow/uikit/core/components/Icon/IconTrash';
import IconDraggable from '@dealroadshow/uikit/core/components/Icon/IconDraggable';
import { Field } from '@/Framework/UI/Organisms/FinalForm';
import {
  IFieldData, TSetFieldsData,
} from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/ManagePortfoliosModal/ManagePortfoliosModal';
import DeletePortfolioModal from './DeletePortfolioModal';

import styles from './managePortfoliosModal.scss';

interface IProps {
  idOfVisibleDeleteModal: number,
  setIdOfVisibleDeleteModal: Dispatch<SetStateAction<number>>,
  fieldData: IFieldData,
  index: number,
  setFieldsData: TSetFieldsData,
}

const SortablePortfolio = ({
  idOfVisibleDeleteModal,
  setIdOfVisibleDeleteModal,
  fieldData,
  index,
  setFieldsData,
}: IProps) => {
  const {
    attributes,
    listeners,
    setNodeRef: draggableItemRef,
    transform,
    transition,
  } = useSortable({ id: fieldData.id });

  const draggableStyle = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  const preventClosingDeleteModal = (e) => {
    e.stopPropagation();
  };

  const onDeleteAreaClick = (e) => {
    preventClosingDeleteModal(e);
    setIdOfVisibleDeleteModal(index);
  };

  const onCancel = useCallback(() => setIdOfVisibleDeleteModal(null), []);

  return (
    <div
      ref={ draggableItemRef }
      style={ draggableStyle }
      className={ styles.portfolio }
      data-test={ `draggableArea-${ index }` }
    >
      <div className={ styles.draggableArea } { ...attributes } { ...listeners }>
        <div className={ styles.sequenceNumber }>{ index + 1 }</div>
        <IconDraggable className={ styles.draggableIcon } />
      </div>
      <div className={ styles.fieldContainer }>
        <Field
          name={ fieldData.id }
          component={ Input }
          placeholder="Name of the portfolio"
          dataTest={ `portfolioNameInput-${ index }` }
        />
      </div>
      <DeletePortfolioModal
        fieldData={ fieldData }
        visibleDeleteModalId={ idOfVisibleDeleteModal }
        onCancel={ onCancel }
        deleteModalId={ index }
        setFieldsData={ setFieldsData }
      >
        <div
          className={ styles.deleteIconContainer }
          onClick={ onDeleteAreaClick }
          data-test={ `deleteIcon-${ index }` }
        >
          <IconTrash className={ styles.deleteIcon } />
        </div>
      </DeletePortfolioModal>
    </div>
  );
};

export default SortablePortfolio;
